import React, { useState } from 'react';
import { useHistory } from 'react-router';

import { useRequest } from '../../hooks';
import { SubmitButton } from '../../components';
import { Form, FormItem, Input } from '../../components';
import { notify, useAuth } from '../../shared';
import type { LoginRequest } from '../../api';

type FormType = LoginRequest;

const LoginPage: React.FC = () => {
  const { login, check } = useAuth();
  const history = useHistory();

  const [values, setValues] = useState<FormType>({
    username: '',
    password: '',
  });
  const [handleLogin, loading] = useRequest(() => login(values), {
    deps: [values],
    onSuccess: data => {
      data && history.push('/');
      check();
    },
    onError: () => {
      notify.error('Failed to login');
    },
  });

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
      className="h-full w-full flex items-center justify-center"
    >
      <form
        onSubmit={e => e.preventDefault()}
        className="w-[40rem] flex flex-col gap-y-md bg-content p-2xl rounded-md text-text"
      >
        <div className="text-center text-heading font-bold mb-md">
          Outreach Admin
        </div>
        <div className="text-center text-medium text-textLight mb-lg">
          Please login to continue
        </div>
        <Form<FormType> initialValue={values} onChange={setValues}>
          <FormItem<FormType> label="Username" name="username" inline={false}>
            <Input autoComplete="username" />
          </FormItem>
          <FormItem<FormType> label="Password" name="password" inline={false}>
            <Input type="password" autoComplete="current-password" />
          </FormItem>
          <SubmitButton
            type="primary"
            className="mt-lg"
            loading={loading}
            onClick={handleLogin}
            textSizeClassName="text-medium"
          >
            Login
          </SubmitButton>
        </Form>
      </form>
    </div>
  );
};

export default React.memo(LoginPage) as typeof LoginPage;
